import React from 'react';
import { Construction, Mail } from 'lucide-react';

const MaintenancePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-6">
      <div className="max-w-lg w-full text-center space-y-8">
        <div className="flex justify-center">
          <div className="w-24 h-24 rounded-full bg-amber-500/20 flex items-center justify-center animate-pulse">
            <Construction className="w-12 h-12 text-amber-400" />
          </div>
        </div>

        <div className="space-y-4">
          <h1 className="text-4xl font-bold text-white tracking-tight">
            Maintenance en cours
          </h1>
          <p className="text-lg text-slate-300 leading-relaxed">
            Notre site est actuellement en maintenance pour vous offrir une meilleure expérience.
            Nous serons de retour très bientôt.
          </p>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6 space-y-3">
          <p className="text-slate-400 text-sm">
            Pour toute question urgente, contactez-nous par email :
          </p>
          <a
            href="mailto:contact@sakane.ma"
            className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 font-medium transition-colors"
          >
            <Mail className="w-5 h-5" />
            contact@sakane.ma
          </a>
        </div>

        <p className="text-slate-500 text-sm">
          Merci de votre patience et de votre compréhension.
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
